import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AllvendorCategoryPriorty } from "../../../FetchAPI";
import APIDataFetchLoader from "../../../Others/APIDataFetchLoader";
import LeadAddValidation from "./LeadAddValidation";
import Sidebar from "../../Sidebar";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../../DeshBoardFooter";
import NotifyMessageNoReload from "../../../Others/NotifyMessageNoReload";
import { useAuth } from "../../../../Store/AuthContext";
import { Helmet } from "react-helmet";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadAdd() {
  const { userID, RendomTokenfetch, userRoll } = useAuth();

  const navigate = useNavigate();

  const [statusPriority] = AllvendorCategoryPriorty(RendomTokenfetch);

  // console.log(statusPriority);

  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [subServices, setSubServices] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedsubServices, setSelectedsubServices] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formValiderror, setformValiderror] = useState({});

  // Fetch categories on component mount
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    const FetchVendorcatData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getallcategoryvendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCategories(response.data.catdata || []);
            }
            if (response.data.Status === "0") {
              setCategories([]);
            }
          });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchVendorcatData();
  }, [RendomTokenfetch, userID]);

  // Fetch services when category changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", selectedCategory);
    const FetchVendorServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}allcatservicevendor`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setServices(response.data.servicedata || []);
              setSubServices([]);
              setStates([]);
              setCities([]);
            }
            if (response.data.Status === "0") {
              setServices([]);
              setSubServices([]);
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchVendorServiceData();
  }, [RendomTokenfetch, selectedCategory, userID]);

  // Fetch sub-services and states when service changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("serviceid", selectedService);
    fdata.append("catid", selectedCategory);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}StateAndSubservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setSubServices(response.data.servicedata || []);
              setStates(response.data.statedata || []);
              setCities([]);
            } else {
              setSubServices([]);
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchSubServiceStateData();
  }, [RendomTokenfetch, selectedService, selectedCategory, userID]);

  // Fetch cities when state changes
  useEffect(() => {
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", selectedCategory);
    fdata.append("serviceid", selectedService);
    fdata.append("stateid", selectedState);

    const FetchServiceCityData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}getServiceStateCity`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setCities(response.data.citydata || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServiceCityData();
  }, [
    RendomTokenfetch,
    selectedService,
    selectedCategory,
    selectedState,
    userID,
  ]);

  const [mobileNumber, setMobileNumber] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
      setWhatsappNumber(value);
    }
  };

  const handleWhatsappChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setWhatsappNumber(value);
    }
  };

  const [applicantName, setapplicantName] = useState("");
  const [clientQuotation, setclientQuotation] = useState("");
  const [priorityStatus, setpriorityStatus] = useState("");
  const [description, setdescriptions] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("userroll", userRoll);
    fdata.append("name", applicantName);
    fdata.append("number", mobileNumber);
    fdata.append("whatsappnumber", whatsappNumber);
    fdata.append("category", selectedCategory);
    fdata.append("service", selectedService);
    fdata.append("subService", selectedsubServices);
    fdata.append("state", selectedState);
    fdata.append("city", selectedcity);
    fdata.append("clientQuotation", clientQuotation);
    fdata.append("statusPriority", priorityStatus);
    fdata.append("description", description);

    axios
      .post(`${WebsiteAPIurl}vendorleadAdd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (applicantName && mobileNumber && selectedCategory) {
          if (response.data.Status === "0") {
            NotifyMessageNoReload(response.data.msg, "danger");
            setformValiderror(LeadAddValidation(response.data.form_validation));
          }

          if (response.data.Status === "1") {
            NotifyMessageNoReload(response.data.msg, "success");
            navigate("/my-assign-lead");
          }
        } else {
          setformValiderror(LeadAddValidation(response.data.form_validation));
        }
      });
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (error) {
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Vendor Lead Add" }]} />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-12">
                <div className="ls-widget">
                  <div className="tabs-box">
                    {/* <div className="widget-title">
                      <h3>Lead Add</h3>
                    </div> */}
                    <div className="widget-content py-4">
                      <form className="was-validated" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label htmlFor="name">Name</label>
                            <input
                              type="text"
                              value={applicantName}
                              onChange={(e) => setapplicantName(e.target.value)}
                              className="form-control"
                              required
                            />
                            <div className="invalid-feedback">
                              {formValiderror.name && formValiderror.name}
                            </div>
                            {/* {formValiderror.name && (
                              <span className="text-danger">
                                * {formValiderror.name}
                              </span>
                            )} */}
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Mobile Number</label>
                            <div className="input-group">
                              <span className="input-group-text">+91</span>
                              <input
                                type="text"
                                className="form-control"
                                name="mobileNumber"
                                onChange={handleMobileChange}
                                onKeyPress={handleKeyPress}
                                defaultValue={mobileNumber}
                                maxLength={10}
                                inputMode="numeric"
                                required
                              />
                            </div>
                            <div className="invalid-feedback">
                              {formValiderror.number && formValiderror.number}
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Whatsapp Number</label>
                            <div className="input-group">
                              <span className="input-group-text">+91</span>
                              <input
                                type="text"
                                className="form-control"
                                name="whatsappNumber"
                                onChange={handleWhatsappChange}
                                defaultValue={whatsappNumber}
                                onKeyPress={handleKeyPress}
                                inputMode="numeric"
                                maxLength={10}
                              />
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Category</label>
                            <select
                              className="form-control"
                              value={selectedCategory}
                              onChange={(e) =>
                                setSelectedCategory(e.target.value)
                              }
                              required
                            >
                              <option value="">Select Category</option>
                              {categories.map((val) => (
                                <option value={val.id} key={val.id}>
                                  {val.category}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback">
                              {formValiderror.category &&
                                formValiderror.category}
                            </div>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Service</label>
                            <select
                              className="form-control"
                              value={selectedService}
                              onChange={(e) =>
                                setSelectedService(e.target.value)
                              }
                              disabled={!services.length}
                              required
                            >
                              <option value="">Select Service</option>
                              {services.map((value) => (
                                <option value={value.id} key={value.id}>
                                  {value.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Sub Service</label>
                            <select
                              className="form-control"
                              value={selectedsubServices}
                              onChange={(e) =>
                                setSelectedsubServices(e.target.value)
                              }
                              disabled={!subServices.length}
                            >
                              <option value="">Select Sub Service</option>
                              {subServices.map((subService) => (
                                <option
                                  value={subService.id}
                                  key={subService.id}
                                >
                                  {subService.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>State</label>
                            <select
                              className="form-control"
                              value={selectedState}
                              onChange={(e) => setSelectedState(e.target.value)}
                              disabled={!states.length}
                              required={states.length}
                            >
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option value={state.id} key={state.id}>
                                  {state.state}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>City</label>
                            <select
                              className="form-control"
                              value={selectedcity}
                              onChange={(e) => setSelectedcity(e.target.value)}
                              disabled={!cities.length}
                              required={cities.length}
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option value={city.id} key={city.id}>
                                  {city.city}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Client Quotation</label>
                            <input
                              type="number"
                              value={clientQuotation}
                              onChange={(e) =>
                                setclientQuotation(e.target.value)
                              }
                              className="form-control"
                            />
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 mb-3">
                            <label>Status Priority</label>
                            <select
                              className="chosen-select form-control"
                              value={priorityStatus}
                              onChange={(e) =>
                                setpriorityStatus(e.target.value)
                              }
                            >
                              <option value="">Select</option>
                              {statusPriority &&
                                statusPriority.map((val, index) => (
                                  <option value={val.id} key={index}>
                                    {val.stauspreority}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Description</label>
                            <textarea
                              value={description}
                              onChange={(e) => setdescriptions(e.target.value)}
                              rows={4}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12 text-center mt-3">
                          <button className="theme-btn btn-style-three submitbtn">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
